<template>
	<div class="wx-login-callback">
		<div v-if="loading" class="loading">
			<el-alert title="正在处理微信登录..." type="info" :closable="false" show-icon></el-alert>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex';
	import TMessage from '@/utils/TMessage';
	import CUser from '@/utils/User';
	import { SITE_URL, LOGIN_TYPE_PERSONAL, LOGIN_TYPE_ENTERPRISE } from '@/data/siteConfig';
	import { goLoginRedirect } from '@/utils/complianceEntry';

	export default {
		name: 'WxLoginCallback',
		data() {
			return {
				loading: true,
				error: '',
				code: ''
			};
		},
		mounted() {
			this.handleWxLoginCallback();
		},

		computed: {
			...mapGetters('Settings', ['sLoginShow', 'sWechatBindShow'])
		},

		methods: {
			...mapActions('User', ['login', 'enterpriseLogin', 'getUserInfo', 'getCorporateList', 'chooseCorporate', 'logout']),
			...mapActions('Settings', ['setWechatBindShow', 'setLoginShow']),

			// 处理微信登录回调
			async handleWxLoginCallback() {
				try {
					// 获取URL中的code参数
					this.code = this.getUrlParam('code');
					const state = this.getUrlParam('state');

					console.log('this.code',this.code)

					if (!this.code) {
						throw new Error('未获取到微信授权code');
					}
					if (state.indexOf('pBind') >= 0) {
						//绑定微信号
						this.wechatBindPersonal();
					} else if (state.indexOf('cBind') >= 0) {
						this.wechatBindCorporate();
					} else if (state.indexOf('pLogin') >= 0) {
						//登录
						this.wechatLoginPersonal();
					} else {
						this.wechatLoginEnterprise();
					}
				} catch (error) {
					console.error('微信回调失败:', error);
					this.error = error.message || '微信回调失败，请重试';
					this.loading = false;
				}
			},

			// 微信登录-个人（4种情况）
			wechatLoginPersonal() {
				const loginParams = {
					code: this.code,
					itype: 0
				};
				console.log('微信登录参数-个人:', loginParams);
				this.$store
					.dispatch('User/login', loginParams)
					.then(async () => {
						// 登录成功 → token 已由 action 写入 localStorage + 跨域 cookie
						CUser.setLoginType(LOGIN_TYPE_PERSONAL);
						const token = CUser.getToken();
						// 直接跳转个人版子域名，手机号校验由个人版路由守卫处理
						// 微信扫码回调已无手势：wxLogin 标记走 location.replace 整页直达（合规有权限直达合规，否则落个人版）
						await goLoginRedirect(SITE_URL.PERSON, token, null, window.parent, false, true);
					})
					.catch(err => {
						if (err.code > 600) {
							// 情况3：微信号未注册 → 通知父窗口
							console.log('微信登录失败-未注册:', err);
							window.parent.postMessage(
								{
									type: 'wechatLoginFail',
									msg: err.msg || '该微信号暂未注册，请先注册'
								},
								'*'
							);
						} else {
							// 情况4：其他错误
							TMessage.error(err.msg || '登录失败');
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},

			// 微信登录-企业（4种情况）
			wechatLoginEnterprise() {
				const loginParams = {
					code: this.code,
					itype: 0

				};
				console.log('微信登录参数-企业:', loginParams);
				this.$store
					.dispatch('User/enterpriseLogin', loginParams)
					.then(async () => {
						// 登录成功 → token 已由 action 写入 localStorage + 跨域 cookie
						CUser.setLoginType(LOGIN_TYPE_ENTERPRISE);
						const token = CUser.getToken();

						try {
							const res = await this.getCorporateList();
							// 过滤有效企业：isLock==0 且 排除子账号基本版(isMain==0 && corporateLevel==0)
							const validList = (res.data || []).filter(item => item.isLock == 0 );

							if (validList.length === 0) {
								// 情况3：无有效企业 → 退出并通知父窗口
								this.$store.dispatch('User/logout');
								window.parent.postMessage(
									{
										type: 'wechatLoginFail',
										msg: '该手机号码暂没有绑定有效账号'
									},
									'*'
								);
								return;
							}

							if (validList.length === 1) {
								// 情况1：仅一家企业 → 选中并跳转企业版子域名
								this.chooseCorporate(validList[0]);
								// 微信扫码回调已无手势：wxLogin 标记走 location.replace 整页直达（合规/评审有权限直达工具，否则落企业版）
								await goLoginRedirect(SITE_URL.COMPANY, token, validList[0], window.parent, false, true);
								return;
							}

							// 情况2：多家企业 → 通知父窗口弹出企业选择器
							this.onSuccessLogin(validList);
						} catch (error) {
							// 情况4：获取企业列表异常
							console.error('获取企业列表失败:', error);
							window.parent.postMessage(
								{
									type: 'wechatLoginFail',
									msg: '获取企业列表失败，请重试'
								},
								'*'
							);
						}
					})
					.catch(err => {
						if (err.code > 600) {
							console.log('企业微信登录失败:', err);
							window.parent.postMessage(
								{
									type: 'wechatLoginFail',
									msg: err.msg || '登录失败'
								},
								'*'
							);
						} else {
							TMessage.error(err.msg || '登录失败');
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},

			// 微信绑定-个人版
			wechatBindPersonal() {
				console.log('微信绑定-个人版, code:', this.code);
				this.$store
					.dispatch('User/bindWechat', this.code)
					.then(() => {
						this.onSuccessBindPersonal();
					})
					.catch(err => {
						if (err.code > 600) {
							window.parent.postMessage({
								type: 'wechatBindFail',
								msg: err.msg || '微信绑定失败',
								code: err.code
							}, '*');
						} else {
							TMessage.error(err.msg || '微信绑定失败');
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},

			// 微信绑定-企业版（暂未开放，预留）
			wechatBindCorporate() {
				console.log('微信绑定-企业版, code:', this.code);
				this.$store
					.dispatch('User/enterpriseBindWechat', this.code)
					.then(() => {
						this.onSuccessBindCorporate();
					})
					.catch(err => {
						if (err.code > 600) {
							window.parent.postMessage({
								type: 'wechatBindFail',
								msg: err.msg || '微信绑定失败',
								code: err.code
							}, '*');
						} else {
							TMessage.error(err.msg || '微信绑定失败');
						}
					})
					.finally(() => {
						this.loading = false;
					});
			},

			// 登录成功通知父窗口（仅企业多公司场景使用，个人版/单企业已在回调页直接跳转）
			onSuccessLogin(companyList) {
				if (window.parent && window.parent !== window) {
					console.log('向父窗口发送 wechatLoginSuccess 消息');
					window.parent.postMessage(
						{
							type: 'wechatLoginSuccess',
							msg: '登录成功',
							companyList: companyList || null
						},
						'*'
					);
				}

				// 延迟关闭当前页面（iframe中的页面）
				setTimeout(() => {
					window.location.href = 'about:blank';
				}, 1000);
			},

			//绑定微信后执行--个人
			onSuccessBindPersonal() {
				// 向父窗口(LoginBox)发送消息
				if (window.parent && window.parent !== window) {
					console.log('个人版-向父窗口发送 wechatBindSuccess 消息');
					window.parent.postMessage(
						{
							type: 'wechatBindSuccess',
							msg: '绑定成功'
						},
						'*'
					);
				}

				// 延迟关闭当前页面
				setTimeout(() => {
					window.location.href = 'about:blank';
				}, 1000);
			},

			// 绑定微信后执行--企业
			onSuccessBindCorporate() {
				// 向父窗口(LoginBox)发送消息
				if (window.parent && window.parent !== window) {
					console.log('企业版-向父窗口发送 wechatBindSuccess 消息');
					window.parent.postMessage(
						{
							type: 'wechatBindSuccess',
							msg: '绑定成功'
						},
						'*'
					);
				}

				// 延迟关闭当前页面
				setTimeout(() => {
					window.location.href = 'about:blank';
				}, 1000);
			},

			// 获取URL参数
			getUrlParam(name) {
				const urlParams = new URLSearchParams(window.location.search);
				return urlParams.get(name);
			},

			// 跳转到首页
			goHome() {
				window.location.href = '/';
			},

			// 返回登录页面
			goBack() {
				window.location.href = '/login';
			}
		}
	};
</script>

<style lang="less" scoped>
	.wx-login-callback {
		display: flex;
		justify-content: center;
		align-items: center;
		min-height: 100vh;
		padding: 20px;

		.loading,
		.error,
		.success {
			text-align: center;
			max-width: 400px;
			width: 100%;
		}

		.el-alert {
			margin-bottom: 20px;
		}
	}
</style>
